import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.75593 4.41077C9.43051 4.08533 8.90287 4.08533 8.57743 4.41077L3.57743 9.41077C3.25199 9.73621 3.25199 10.2638 3.57743 10.5893L8.57743 15.5893C8.90287 15.9147 9.43051 15.9147 9.75593 15.5893C10.0814 15.2638 10.0814 14.7362 9.75593 14.4108L6.17853 10.8333H15.8333C16.2936 10.8333 16.6667 10.4603 16.6667 10C16.6667 9.53979 16.2936 9.16669 15.8333 9.16669H6.17853L9.75593 5.58929C10.0814 5.26385 10.0814 4.73621 9.75593 4.41077Z",
		fill: "currentColor"
	})
});
export default SvgLeft;
